export default class FuelTypes{

    constructor()
    {
        this.fuelTypes = [
            {
                value: 'diesel',
                label:'Diesel',
                key: 'FUEL_DIESEL'
            },
            {
                value: 'essence',
                label:'Essence',
                key: 'FUEL_ESSENCE'
            },
            {
                value: 'lpg',
                label:'Gaz / LPG',
                key: 'FUEL_LPG'
            },
            {
                value: 'electrique',
                label:'Electric',
                key:'FUEL_ELECTRIC'
            }
            ];
    }

    fuelTypes: SingleFuel[];
}

interface SingleFuel{
    value: string;
    label: string;
    key: string;
}